import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  isActionCompleted: false,
  isAction1Completed: false,
  isAction2Completed: false,
  isAction3Completed: false,
  comp_id: "",
  totalCount: 0,
  entities: [],
  finCompanyForEdit: {
    id: "",
    company_last_name: "",
    company_first_name: "",
    title: "",
    mobile: "",
    isActive: "",
    allowNoti: false,
    fax: "",
    whatsapp_name: "",
    skype_name: "",
    email: "",
    phone: "",
    company_name: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    com_phone: "",
    com_fax: "",
    com_email: "",
    website: "",
    com_year: "",
    radioGroup: true,
    company_type: [],
    service_company: [],
    service_year: "",
    share: "",
    description: "",
    countryName: "",
    stateName: "",
    cityName: "",
    serviceTypesOther: "",
    servicesOfferedOther: "",
    isApproved: false,
  },
  message: null,
  messageType: null,
  showMessage: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const finCompanySlice = createSlice({
  name: "finCompany",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // location loader
    finCompanyListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    finCompanyList: (state, action) => {
      const { result, count } = action.payload;

      let tempArray = [];

      result.forEach(item => {
        let tempObj = {
          id: item.id,
          company_first_name: item.firstName,
          company_last_name: item.lastName,
          email: item.email,
          title: item.title,
          mobile: item.mobile,
          allowNoti: item.allowNotification,
          fax: item.fax,
          display_name: item.displayName,
          whatsapp_name: item.whatsAppUsername,
          skype_name: item.skypeUsername,
          phone: item.phoneno,
          company_name: item.organization?.name,
          address: item.organization?.locations[0]?.street1,
          countryName: item.organization?.locations[0]?.countryName,
          stateName: item.organization?.locations[0]?.stateName,
          cityName: item.organization?.locations[0]?.cityName,
          pincode: item.organization?.locations[0]?.pincode,
          com_phone: item.organization?.phoneNo,
          com_fax: item.organization?.fax,
          com_email: item.organization?.email,
          website: item.organization?.website,
          com_year: item.organization?.yearsInBusiness,
          radioGroup: item.organization?.acceptCCPayment,
          company_type: item.organization?.serviceTypes,
          service_company: item.organization?.servicesOffered,
          service_year: item.organization?.minBusinessYear,
          share: item.organization?.commissionPercentage,
          description: item.organization?.currentOffering,
          createdAt: item.createdAt,
          serviceTypesOther: item.organization?.serviceTypesOther,
          servicesOfferedOther: item.organization?.servicesOfferedOther,
          isActive: item.isActive,
          isApproved: item.isApproved,
          userOrg: item.userOrg,
        };

        tempArray.push(tempObj);
      });

      state.totalCount = count;
      state.entities = tempArray;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadfinCompanyForEdit: (state, action) => {
      const item = action.payload;

      let temp = {
        company_contact_name: item.name,
        id: item.id,
        company_first_name: item.firstName,
        company_last_name: item.lastName,
        email: item.email,
        title: item.title,
        mobile: item.mobile,
        allowNoti: item.allowNotification,
        fax: item.fax,
        display_name: item.displayName,
        whatsapp_name: item.whatsAppUsername,
        skype_name: item.skypeUsername,
        phone: item.phoneno,
        organizationId: item.userOrg[0].organization.id,
        company_name: item.userOrg[0].organization.name,
        locationId: item.userOrg[0].organization.locations[0]?.id,
        address: item.userOrg[0].organization.locations[0]?.street1,
        countryName: item.userOrg[0].organization.locations[0]?.countryName,
        stateName: item.userOrg[0].organization.locations[0]?.stateName,
        cityName: item.userOrg[0].organization.locations[0]?.cityName,
        pincode: item.userOrg[0].organization.locations[0]?.pincode,
        address2: item.userOrg[0].organization.locations[0]?.street2,
        com_phone: item.userOrg[0].organization.phoneNo,
        com_fax: item.organization?.phoneNo,
        com_email: item.userOrg[0].organization.email,
        website: item.userOrg[0].organization.website,
        com_year: item.userOrg[0].organization.yearsInBusiness,
        radioGroup: item.userOrg[0].organization.acceptCCPayment,
        transport_type: item.userOrg[0].organization.serviceTypes,
        logistic_type: item.userOrg[0].organization.servicesOffered,
        service_year: item.userOrg[0].organization.minBusinessYear,
        share: item.userOrg[0].organization.commissionPercentage,
        description: item.userOrg[0].organization.companyDescription,
        product: item.userOrg[0].organization.productsOffered,
        finance_amt: item.userOrg[0].organization.currentOffering,
        terms_condition: item.userOrg[0].organization.TermsAndConditions,
        companyfax: item.userOrg[0].organization.fax,
        pic: item.userOrg[0].organization.logo,
        createdAt: item.createdAt,
        serviceTypesOther: item.userOrg[0].organization.serviceTypesOther,
        servicesOfferedOther: item.userOrg[0].organization.servicesOfferedOther,
        isActive: item.isActive,
        isApproved: item.isApproved,
      };

      state.finCompanyForEdit = temp;
    },
    loadfinCompanyMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    saveCompleteAction: (state, action) => {
      const { value, id } = action.payload;

      state.isActionCompleted = value;
      if (id != null) state.comp_id = id;
    },
    saveComplete1Action: (state, action) => {
      state.isAction1Completed = action.payload;
    },
    saveComplete2Action: (state, action) => {
      state.isAction2Completed = action.payload;
    },
    saveComplete3Action: (state, action) => {
      state.isAction3Completed = action.payload;
    },
  },
});
